import { Direction } from '../types/icon.types';

export const getRotate = (direction: Direction): number => ({
  top: 180,
  right: -90,
  left: 90,
  bottom: 0,
}[direction]);
